import QRCode from 'qrcode';
import { useEffect, useState } from 'react';

/** Desenha o QR code no navegador; o segredo não passa por serviço externo. */
export function QrCode({ value, label }: { value: string; label: string }) {
  const [src, setSrc] = useState<string>();

  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(value, { margin: 1, width: 192, errorCorrectionLevel: 'M' })
      .then((url) => {
        if (!cancelled) setSrc(url);
      })
      .catch(() => {
        if (!cancelled) setSrc(undefined);
      });
    return () => {
      cancelled = true;
    };
  }, [value]);

  if (!src) return <div className="skeleton" style={{ width: 192, height: 192 }} aria-hidden="true" />;
  return (
    <img
      src={src}
      width={192}
      height={192}
      alt={label} // fundo branco fixo de propósito: o leitor de QR precisa de contraste, inclusive no tema escuro
      style={{ background: '#fff', borderRadius: 6 }}
    />
  );
}
